module.exports = __webpack_public_path__ + "ddc785c66189ee5d1361aa0e3f146b02.svg";